const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const SESSION_TOKEN_KEY = "spike_auth_token";

export function getSessionToken() {
  return window.localStorage.getItem(SESSION_TOKEN_KEY) || "";
}

async function requestEaJson(path, options = {}) {
  const token = getSessionToken();

  if (!token) {
    throw new Error("Authorization token is required");
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const responseText = await response.text();
  let payload = {};

  if (responseText) {
    try {
      payload = JSON.parse(responseText);
    } catch (error) {
      payload = {
        message: responseText,
      };
    }
  }

  if (!response.ok) {
    throw new Error(payload.message || "Request failed");
  }

  return payload;
}

export function getEaApiKey() {
  return requestEaJson("/api/user/ea/key");
}

export function regenerateEaApiKey() {
  return requestEaJson("/api/user/ea/key/regenerate", { method: "POST" });
}

export function getEaSettings() {
  return requestEaJson("/api/user/ea/settings");
}

export function updateEaSettings(patch) {
  return requestEaJson("/api/user/ea/settings", {
    method: "PUT",
    body: JSON.stringify(patch),
  });
}

export function getWatchlist() {
  return requestEaJson("/api/alerts/watchlist");
}

export function addWatchlistEntry({ symbol, timeframe, slPips, tpPips }) {
  return requestEaJson("/api/alerts/watchlist", {
    method: "POST",
    body: JSON.stringify({ symbol, timeframe, slPips, tpPips }),
  });
}

export function removeWatchlistEntry(id) {
  return requestEaJson(`/api/alerts/watchlist/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}

export function getEaSignals(limit = 50) {
  return requestEaJson(`/api/user/ea/signals?limit=${encodeURIComponent(limit)}`);
}

export function getEaEvents(limit = 50) {
  return requestEaJson(`/api/user/ea/events?limit=${encodeURIComponent(limit)}`);
}
